<template>
  <v-select
    :multiple="multiple"
    :options="options"
    :label="label"
    :value="value"
    :placeholder="placeholder"
    :name="name"
    :id="id"
    @input="onInput"
  >
    <template slot="no-options">{{ noOptionsText }}</template>
  </v-select>
</template>

<script>
import autoApi from '@/services/auto.api';
import { ALL_BROKERS_OPTION } from '@/utils/constants';
import vSelect from 'vue-select';
import { PERMISSIONS_ACTIONS } from '../../constants/permissions';

export default {
  name: 'PermissionedAutocomplete',
  components: {
    'v-select': vSelect,
  },
  props: {
    value: {
      type: [Array, Object],
      default: null,
    },
    source: {
      type: String,
      required: true,
      validator: (value) => ['broker', 'user'].includes(value),
    },
    permissionSubject: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'label',
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    includeAllBrokersOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      loading: false,
    };
  },
  computed: {
    noOptionsText() {
      return this.loading ? 'Carregando opções' : 'Nenhuma opção encontrada';
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    hasFullReading() {
      return this.$can(
        PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
        this.permissionSubject,
      );
    },
    fetchOptions() {
      const endpoints = {
        broker: {
          list: () => autoApi.getBrokersList(),
          byUser: () => autoApi.getAccessibleBrokers(),
        },
        user: {
          list: () => autoApi.getUsersList(),
          byUser: () => autoApi.getAccessibleUsers(),
        },
      }[this.source];

      return this.hasFullReading() ? endpoints.list() : endpoints.byUser();
    },
    async load() {
      try {
        this.loading = true;
        const response = await this.fetchOptions();
        this.setOptions(response);
      } catch (error) {
        this.notifyError();
      } finally {
        this.loading = false;
      }
    },
    setOptions(response) {
      const options = (response || [])
        .map((item) => ({ id: item.id, label: item.label }))
        .sort((a, b) => a.label.localeCompare(b.label));

      if (
        this.includeAllBrokersOption &&
        !this.multiple &&
        options.length > 1
      ) {
        options.unshift({
          id: ALL_BROKERS_OPTION.ID,
          label: ALL_BROKERS_OPTION.LABEL,
        });
      }

      this.options = options;
    },
    notifyError() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text:
          this.source === 'broker'
            ? 'Erro ao buscar as corretoras'
            : 'Erro ao buscar os usuários',
        color: 'danger',
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
